module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-faded",
    attrs: {
      "id": "team"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "team-member"
  }, [_c('img', {
    staticClass: "mx-auto rounded-circle",
    attrs: {
      "src": require("../../assets/img/team/mathieu.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Mathieu Morainville")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Web Developer | JavaScript-Man")]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline social-buttons"
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.githubMathieu,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.trackClick(_vm.githubMathieu)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.linkedinMathieu,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.trackClick(_vm.linkedinMathieu)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "team-member"
  }, [_c('img', {
    staticClass: "mx-auto rounded-circle",
    attrs: {
      "src": require("../../assets/img/team/sylver.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Sylver-John Imhoff")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Web Developer | Golang Lover")]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline social-buttons"
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.githubSylver,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.trackClick(_vm.githubSylver)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.linkedinSylver,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.trackClick(_vm.linkedinSylver)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])])])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('h2', {
    staticClass: "section-heading"
  }, [_vm._v("The Team")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subheading text-muted"
  }, [_vm._v("\"If it works, refactor it !\"")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2 text-center"
  }, [_c('p', {
    staticClass: "large text-muted"
  }, [_vm._v("We are two young web developers who want to make a better world.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c1bef48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Team.vue
// module id = 116
// module chunks = 1